@if (hasVao) {
  <div>
    <mat-icon class="material-icons">done</mat-icon>
  </div>
} @else {
  <mat-icon class="material-icons">not_interested</mat-icon>
}
